"use strict";

(function () {
      document.addEventListener("DOMContentLoaded", function () {
            // モーダルウィンドウを開くボタン
            const modalButtons = document.querySelectorAll('.mwbtn');
            const modal = document.getElementById('modal');
            const modalContent = document.querySelector('.modal-content');
            const closeButton = document.querySelector('.close-btn');
            const modalOverlay = document.getElementById('modal-overlay');

            modalButtons.forEach(function (button) {
                  button.addEventListener('click', function (e) {
                        e.preventDefault();
                        // モーダルを表示
                        document.body.classList.add('lock-scroll');

                        const dataValue = e.target.dataset.mw;
                        modalContent.classList.add(dataValue);
                        modal.classList.add('active');

                        // チェックボックスをリセット
                        document.querySelectorAll('.shop-sort-list__item input[type="checkbox"]').forEach(function (e) {
                              e.checked = false;
                        });

                        // 表示されているタグに併せてチェックボックスを再設定
                        document.querySelectorAll('.sale-shop-sort-check-list__item').forEach(function (e) {
                              if(window.getComputedStyle(e).display != 'none'){
                                    const elementId = e.id;
                                    const checkbox = document.querySelector(`.shop-sort-list__item input[type="checkbox"][value="${elementId}"]`);
                                    if (checkbox) {
                                          // チェック付ける
                                          checkbox.checked = true;
                                    }
                              }
                        });

                  });
            });

            // 閉じるボタンとオーバーレイのクリックイベント
            if (closeButton) {
                  closeButton.addEventListener('click', closeModal);
            }
            if (modalOverlay) {
                  modalOverlay.addEventListener('click', closeModal);
            }

            // モーダルを閉じる処理
            function closeModal() {
                  modal.querySelectorAll(".active").forEach(function (activeElement) {
                        activeElement.classList.remove('active');
                  });
                  document.body.classList.remove('lock-scroll');

                  // 現在のすべてのクラスを取得し、指定したクラス以外を削除
                  const classToKeep = 'modal-content';
                  modalContent.classList.forEach(cls => {
                        if (cls !== classToKeep) {
                              modalContent.classList.remove(cls);
                        }
                  });

                  modal.classList.remove('active');
            }

      });
})();
